import type { Observation } from "@medplum/fhirtypes";

import { getLaborStageAnswerCode } from "@/encounters/components/EncounterLabor/utils/labor-stage-dedupe";

/**
 * Resolves the labor stage LOINC code to persist for a live (non-queued) flowsheet submit.
 */
export function resolveLiveLaborStageLoincCodeAtSubmit(
  isLaborFlowsheetEntry: boolean,
  laborStageAtSubmit: Observation | undefined,
): string | undefined {
  if (!isLaborFlowsheetEntry || !laborStageAtSubmit) {
    return undefined;
  }

  return getLaborStageAnswerCode(laborStageAtSubmit);
}
